module.exports = __webpack_public_path__ + "static/img/chart.2901a206.svg";